import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShield = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M2.75 6.544c0-.353 0-.53.05-.688.046-.139.12-.267.216-.375.11-.122.26-.207.561-.378l4.877-2.768c.565-.32.847-.48 1.145-.543.265-.056.537-.056.802 0 .298.063.58.223 1.145.543l4.877 2.768c.3.171.451.256.561.378.097.108.17.236.215.375.051.158.051.335.051.688v3.144c0 2.558-1.285 4.935-3.399 6.285l-3.007 1.92c-.306.196-.46.294-.624.332a.973.973 0 0 1-.44 0c-.164-.038-.318-.136-.624-.332l-3.007-1.92c-2.114-1.35-3.399-3.727-3.399-6.285V6.544Z"
	})]
});
const ForwardRef = forwardRef(SvgShield);
export { ForwardRef as ReactComponent };
